import { combineReducers } from "@reduxjs/toolkit";
import dtConsumablesReducer from "./slices/dtConsumables.slice"
import dtResourcesReducer from "./slices/dtResources.slice"
import dtStockExemptionReducer from "./slices/dtStockExemption.slice";
import dtStockInputReducer from "./slices/dtStockInput.slice";
import dtServiceReducer from "./slices/dtService.slice";
import dtRegistrationReducer from "./slices/dtRegistration.slice";
import dtBilledResourcesReducer from "./slices/dtBilledResources.slice";
import dtRefuelsReducer from "./slices/dtRefuels.slice";
import dtReceivablesReducer from "./slices/dtReceivables.slice";
import dtPayablesReducer from "./slices/dtPayables.slice";
import dtStatisticsReducer from "./slices/dtStatistics.slice";

const rootReducer = combineReducers({
    consumables: dtConsumablesReducer,
    resources: dtResourcesReducer,
    inputs: dtStockInputReducer,
    exemptions: dtStockExemptionReducer,
    services: dtServiceReducer,
    resourcesInspections: dtRegistrationReducer,
    charges: dtBilledResourcesReducer,
    refuels: dtRefuelsReducer,
    receivables: dtReceivablesReducer,
    payables: dtPayablesReducer,
    statistics: dtStatisticsReducer
  });
  
  export default rootReducer;
  